import r from"react";import{Box as e}from"../Box/Box.js";var o=function(){return r.createElement(e,{className:"h-5 w-5 border-2 border-t-action-primary rounded-full animate-spin"})};export{o as Spinner};
//# sourceMappingURL=Spinner.js.map
